const createOrderStatusSelector = (
    state: sage.state.IRedux
): sage.status.CreateOrder => {
    return state.balance.createOrderStatus;
};

export default createOrderStatusSelector;
